import React from 'react';

import styled from 'styled-components';

import InfoBox from '@components/ui/InfoNote/InfoBox';
const Container = styled.div`
  font-size: 14px;
  font-weight: 600;
`;
export const renderAdvancePaymentInfoBox = (
  { rate, deadline }: { rate: number; deadline: number },
  {
    margin,
    padding,
    width,
    maxWidth,
    type,
  }: {
    padding?: string;
    width?: string;
    margin?: string;
    maxWidth?: string;
    type?: 'tour' | 'hotel';
  }
) => (
  <InfoBox
    disable={false}
    message={
      <>
        {type === 'tour' ? (
          <>
            <div>
              <b>
                <DoubleQuote>
                  %{rate}
                  &nbsp;önden&nbsp;öde&nbsp;fiyatı&nbsp;sabitle!
                </DoubleQuote>
              </b>{' '}
              kampanyası kapsamında ödenen tutar, rezervasyon tutarınızın %
              {rate}'i olarak hesaplanacaktır. Kalan ödeme tutarını
              rezervasyonunuza {deadline} gün kalaya kadar tamamlamanız
              gerekmektedir.
            </div>
          </>
        ) : (
          <>
            <div>
              <b>
                <DoubleQuote>
                  %{rate}
                  &nbsp;önden&nbsp;öde&nbsp;indirimli&nbsp;fiyatları&nbsp;garantile
                </DoubleQuote>
              </b>{' '}
              kampanyamızdan yararlanmak için aşağıdaki adımda Rezervasyon İptal
              Güvencesi satın almanız gerekmektedir.
            </div>
            <div style={{ marginTop: 10 }}>
              Ödenecek tutar, rezervasyon iptal güvencesi ve rezervasyon
              tutarının %{rate}’inin toplamı olarak hesaplanacaktır. Kalan ödeme
              tutarını, rezervasyonunuza <b>{deadline}&nbsp;gün</b> kala
              tamamlamanız gerekmektedir.
            </div>
            <div>
              * Kalan ödeme tutarı için <b>en fazla 3 taksit</b> yapılabilir.
            </div>
          </>
        )}
      </>
    }
    advancePayment
    {...{ padding, width, margin, maxWidth }}
  />
);

export const isBoundToParentBox = ({
  margin,
  padding,
  width,
  maxWidth,
}: {
  padding?: string;
  width?: string;
  margin?: string;
  maxWidth?: string;
}) => (
  <InfoBox
    disable={false}
    message={
      <div>
        Sepetteki extra hizmet zorunlu olarak tanımlanmıştır. Silinemez.
      </div>
    }
    advancePayment
    {...{ padding, width, margin, maxWidth }}
  />
);

export const isScoreCardBox = ({
  margin,
  padding,
  width,
  maxWidth,
}: {
  padding?: string;
  width?: string;
  margin?: string;
  maxWidth?: string;
}) => (
  <InfoBox
    hasReference={true}
    disable={false}
    message={
      <Container>
        Çevrilecek Puan Tutarı, kredi kartınızdaki Mevcut Puan'dan fazla olamaz.
      </Container>
    }
    advancePayment
    {...{ padding, width, margin, maxWidth }}
  />
);

export const PersonQuotaWarning = (
  { personQuota }: { personQuota: number },
  {
    margin,
    padding,
    width,
    maxWidth,
  }: {
    padding?: string;
    width?: string;
    margin?: string;
    maxWidth?: string;
  }
) => (
  <InfoBox
    disable={true}
    message={
      <div>
        Seçtiğiniz tarihlerde {personQuota} kişilik yer kalmıştır. Bu
        rezervasyon talebinizle ilgili olarak <strong> 444 28 22 </strong>
        numaralı çağrı merkezimizden veya satış ofisimizden yardım
        alabilirsiniz.
      </div>
    }
    advancePayment
    {...{ padding, width, margin, maxWidth }}
  />
);

export const PriceQuotaWarning = ({
  margin,
  padding,
  width,
  maxWidth,
}: {
  padding?: string;
  width?: string;
  margin?: string;
  maxWidth?: string;
}) => (
  <InfoBox
    disable={true}
    message={
      <div>
        Seçtiğiniz tarihlerde 3 kişilik fiyat bulunamadı. Bu rezervasyon
        talebinizle ilgili olarak <strong> 444 28 22 </strong>
        numaralı çağrı merkezimizden veya satış ofisimizden yardım
        alabilirsiniz.
      </div>
    }
    advancePayment
    {...{ padding, width, margin, maxWidth }}
  />
);

const DoubleQuote = ({ children }: React.PropsWithChildren<unknown>) => (
  <span>
    <span>&#8220;</span>
    {children}
    <span>&#8221;</span>
  </span>
);

/**
 * %1 önden öde indirimli fiyatları garantile’ kampanyamızdan yararlanmak için aşağıdaki adımda Rezervasyon İptal Güvencesi satın almanız gerekmektedir. 
Ödenecek tutar, rezervasyon iptal güvencesi ve rezervasyon tutarınızın %1’inin toplamı olarak hesaplanacaktır. Kalan ödeme tutarını, rezervasyonunuza 14 gün kala tamamlamanız gerekmektedir.
 */
